import { useState } from 'react';

import { observer } from 'mobx-react-lite';
import { Divider } from '@mui/material';

import { useParams } from 'react-router';
import { LoadingPlaceholder } from '../../../components/LoadingPlaceholder';
import ClinicalEventModal from './Drawer';
import { isEmpty } from 'lodash';
import styles from './index.module.scss';
import useMixpanel from '../../../hooks/useMixpanel';
import ClinicalEventModalProvider from './Drawer/Provider';
import EventsList from './EventsList';
import EventDetails from './EventDetails';
import classNames from 'classnames';
import EmptyEvents from './EmptyEvents';
import useRtmEventsService from './service';
import { ClinicalEventsHeader } from './ClinicalEventsHeader';

const ClinicalEvents = () => {
  const [eventUuid, setEventUuid] = useState<string>('');
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  useMixpanel({ screen: 'new_reported_events', patientUuid });

  const { data, isLoading, isError } = useRtmEventsService(patientUuid);

  const selectedEventUuid = eventUuid || data?.[0]?.uuid;

  if (isError) {
    return null;
  }

  return (
    <LoadingPlaceholder isLoading={isLoading}>
      <ClinicalEventModalProvider>
        <div
          className={classNames(styles.root, {
            [styles.empty]: isEmpty(data),
          })}
        >
          <ClinicalEventsHeader isEmptyEvents={isEmpty(data)} />
          <div className={classNames('flex', styles.eventsContainer)}>
            {!isEmpty(data) ? (
              <>
                <EventsList onChange={(uuid) => setEventUuid(uuid)} uuid={selectedEventUuid} />
                <Divider orientation={'vertical'} flexItem />
                <EventDetails uuid={selectedEventUuid} />
              </>
            ) : (
              <EmptyEvents />
            )}
          </div>
        </div>
        <ClinicalEventModal onChange={(uuid) => setEventUuid(uuid)} />
      </ClinicalEventModalProvider>
    </LoadingPlaceholder>
  );
};

export default observer(ClinicalEvents);
